import Component from '../core/Component'
import { RECAPTCHA_KEY } from '../core/config'

export const STATES = {
    ERROR: 'has-error',
}

export default class RegisterForm extends Component {
    constructor(element) {
        super(element)

        this.shouldSubmit = false
    }

    prepare() {
        this.element.addEventListener('submit', this.handleSubmit)

        if (
            Array.from(this.element.querySelectorAll('.FormItem')).some((input) =>
                input.classList.contains(STATES.ERROR),
            )
        ) {
            this.element.classList.add(STATES.ERROR)
        }

        this.load()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.submit()
    }

    load() {
        const script = document.createElement('script')
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_KEY}`
        script.async = true

        script.onload = () => {
            console.log('Recaptcha loaded')
        }

        script.onerror = () => {
            console.error('Recaptcha failed to load')
        }
        document.head.appendChild(script)
    }

    submit() {
        const isValid = Nette.validateForm(this.element)

        if (!isValid) {
            this.shouldSubmit = false
            return
        }

        this.element.classList.add('is-loading')

        window.grecaptcha.enterprise.ready(async () => {
            const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_KEY, {
                action: 'LOGIN',
            })

            const data = new FormData(this.element)
            data.append('token', token)

            $.nette.ajax({
                url: this.element.action,
                type: this.element.method || 'POST',
                data: data,
                contentType: false,
                processData: false,
                complete: () => {
                    this.element.classList.remove('is-loading')
                },
            })
        })
    }
}
